import EmbedScriptEvent from './event/EmbedScriptEvent';

const ELEMENT_MIN_HEIGHT = 80;

const DEFAULT_STYLES =
	'position: fixed;' +
	'width: 56px;' +
	'height: 56px;' +
	'border-radius: 28px;' +
	'right: 13px;' +
	'bottom: 9px;' +
	'font-size: 16px;' +
	'line-height: 22px;' +
	'cursor: pointer;' +
	'border: none;';

export class AddCommentButton {
	constructor(parentDiscussionInstance) {
		this._parentDiscussionInstance = parentDiscussionInstance;
		this.visible = null;
	}

	render(styles, visibilityData) {
		if (this.element) {
			return this.element;
		}

		this.element = document.createElement('button');
		this.element.textContent = '+';

		this._parentDiscussionInstance._wrapper.appendChild(this.element);

		this.element.style =
			DEFAULT_STYLES +
			`color: rgba(${styles.color}); background-color: rgba(${styles.backGroundColor});`;

		this.element.addEventListener('click', () => {
			this._parentDiscussionInstance.sendEvent(
				EmbedScriptEvent.ADD_COMMENT_BUTTON_CLICKED
			);
			this.destroy();
		});

		this.checkVisibility(visibilityData.window, visibilityData.iframe);

		return this.element;
	}

	// consider replace this with Intersection Observer
	checkVisibility(window, iframe) {
		if (!this.element) {
			return;
		}

		const viewportHeight = window.height;
		const isViewPortUnderIframeTop =
			iframe.top - viewportHeight + ELEMENT_MIN_HEIGHT < 0;
		const isViewPortAboveIframeBottom = iframe.bottom - ELEMENT_MIN_HEIGHT > 0;

		if (isViewPortUnderIframeTop && isViewPortAboveIframeBottom) {
			this.show();
		} else {
			this.hide();
		}
	}

	destroy() {
		if (this.element) {
			this.element.remove();
			this.element = null;
			this.visible = null;
		}
	}

	show() {
		if (this.visible === true) {
			return;
		}

		this.element.style.display = 'block';
		this.visible = true;
	}

	hide() {
		if (this.visible === false) {
			return;
		}

		this.element.style.display = 'none';
		this.visible = false;
	}
}
